import Button from '@berlitz/button'
import Link from 'next/link'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import WithLessonUtilsHOC, { WithLessonUtilsProp } from '@hocs/WithLessonUtils'
import { Anchor } from './style'
import { GroupClassListItem } from '@interfaces/MySchedule'
import useStudentQuery from '@hooks/useStudent'
import Loader from './Loader'

interface Prop {
  url: string
  lesson: GroupClassListItem
  onlyLastLesson?: boolean
}

const CounsellingRegButton: React.FC<Prop & WithLessonUtilsProp> = ({ url, lesson, onlyLastLesson, ...props }) => {
  const studentId = lesson?.SessionInfoList?.[0]?.CustomerId
  const { data, loading } = useStudentQuery(studentId)

  if (loading) {
    return <Loader />
  }

  let showButton = false

  const program = data?.ProgramStudentWrappers?.find(
    (program) => program.ProgramStudentInfo.ProgramId === lesson?.ProgramId
  )
  if (program) {
    const hasContent = Boolean(lesson.CounsellingNextSteps || lesson.CounsellingSessionComments)
    const { ValidforCounselling, CounsellingStatus } = program.ProgramStudentInfo

    const isProgramLesson = props.isProgramLesson({ Type: lesson?.Type ?? '' } as GroupClassListItem)
    const isValidForCounselling = Boolean(ValidforCounselling)
    const isAvailable = CounsellingStatus?.toLowerCase() === 'available'
    const isConfirmed = lesson.Status?.toLocaleLowerCase() === 'confirmed'

    let isLastLesson = true
    if (onlyLastLesson) {
      isLastLesson = Boolean(lesson.ForCounselling)
    }

    showButton = (isProgramLesson && isValidForCounselling && isAvailable && isConfirmed && isLastLesson) || hasContent
  }

  return (
    <>
      {showButton && (
        <Link href={url} legacyBehavior>
          <Anchor>
            <Button outline small>
              <FormattedMessage id="Counselling reg" />
            </Button>
          </Anchor>
        </Link>
      )}
    </>
  )
}

export default React.memo(WithLessonUtilsHOC(CounsellingRegButton))
